const MEMBER_ID_COOKIE = 'member_id';
const MEMBER_COUNTRY_COOKIE = 'ecountry';
const MEMBER_INFO_COOKIE = 'userInfo';
const TGT_TICKET_COOKIE = 'tgt_ticket';
const TGT_TIMESTAMP_COOKIE = 'tgt_timestamp';
const VIEWED_LISTING_COOKIE = 'recentlyViewed'
export {VIEWED_LISTING_COOKIE,MEMBER_COUNTRY_COOKIE,MEMBER_ID_COOKIE,MEMBER_INFO_COOKIE,TGT_TICKET_COOKIE,TGT_TIMESTAMP_COOKIE}